import React from 'react';
import { useLoading } from './LoadingContext';
import LoadingScreen from './LoadingScreen';

function LoadingHandler() {
  const { globalLoading } = useLoading();
  return globalLoading ? <LoadingScreen className="main-loading-screen" /> : null;
}

export default LoadingHandler;